<template>
    <div>
        <el-dialog
            title="站点批量挂起"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="1000px">
            <el-upload
                ref="upload"
                action=""
                :auto-upload="false"
                :on-change="handleFileChange"
                :limit='1'
                accept=".xlsx, .xls">
                <el-button type="primary" icon="el-icon-upload">选择Excel文件</el-button>
                <div slot="tip" class="el-upload__tip">只能上传.xls，.xlsx文件，单次上传最多1000条</div>
            </el-upload>
            <p class="a-fs-14 a-c-yellow a-fw-700" v-if="hasOrderStationList.length">以下站点近3个月有订单：</p>
            <el-table 
                v-if="hasOrderStationList.length"
                ref="errorList"
                :data="hasOrderStationList" 
                :highlight-current-row="true" 
                style="width: 100%;margin-bottom: 20px;">
                <el-table-column prop="" label="站点ID" width="100">
                    <template slot-scope="{ row }">
                        <span>{{ row.stationId?row.stationId:'-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="站点名称" min-width="100">
                    <template slot-scope="{ row }">
                        <span>{{ row.stationName?row.stationName:'-' }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <p class="a-fs-14 a-c-error a-fw-700" v-if="errorData.length">以下站点校验失败：</p>
            <el-table 
                v-if="errorData.length"
                ref="errorList"
                :data="errorData" 
                :highlight-current-row="true" 
                style="width: 100%">
                <el-table-column prop="" label="站点ID" width="100">
                    <template slot-scope="{ row }">
                        <span>{{ row.stationId?row.stationId:'-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="站点名称" min-width="100">
                    <template slot-scope="{ row }">
                        <span>{{ row.stationName?row.stationName:'-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="失败原因" min-width="100">
                    <template slot-scope="{ row }">
                        <span>{{ row.failMessage?row.failMessage:'-' }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="a-flex-rfsc">
                <div class="a-flex-1 a-flex-rfsc">
                    <el-link type="primary" underline @click="handleDownloadFile">模版下载</el-link>
                </div>
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import * as XLSX from 'xlsx';
    export default {
        data() {
            return {
                dialogVisible: false,
                jsonData: [],
                errorData: [],
                hasOrderStationList: []
            }
        },
        watch: {
            dialogVisible: {
                handler (val) {
                    if(!val) {
                        this.$refs['upload'].clearFiles()
                        this.errorData = []
                        this.jsonData = []
                        this.hasOrderStationList = []
                    }
                }
            }
        },
        methods:{
            async submit () {
                if(!this.jsonData.length) {
                    this.$message.error('站点数据为空，请先上传站点列表文件且填写站点数据')
                    return
                }

                if(this.errorData.length) {
                    this.$message.error('站点数据有错误，请检查站点数据')
                    return
                }

                let contentTips = !this.hasOrderStationList.length ? '确认是否挂起？' : '表格中有站点近3个月有订单，确认是否挂起？'

                this.$confirm(contentTips, '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 确定
                    let stationIds = this.jsonData.map(item=>{
                        return item.id
                    })
                    this.$Axios._post({
                        url: this.$Config.apiUrl.setStationHangStatusBatch,
                        params: {
                            "stationIds": stationIds,
                        }
                    }).then(({
                        data
                    }) => {
                        this.dialogVisible = false
                        this.$message.success('站点批量挂起成功')
                        this.$emit('success')
                    })
                })
            },
            handleCheck (stationIds) {
                return new Promise((resolve, reject) => {
                    this.$Axios._post({
                        url: this.$Config.apiUrl.setStationHangStatusBatchCheck,
                        params: {
                            "stationIds": stationIds,
                        }
                    }).then(({
                        data
                    }) => {
                        if(data && data.length) {
                            resolve(data)
                        }else{
                            resolve([])
                        }
                    }).catch(_=>{
                        this.$refs['upload'].clearFiles()
                        reject()
                    })
                })
            },
            async handleFileChange (file) {
                if (file.raw) {
                    try {
                        const jsonData = await this.excelToJson(file.raw);
                        this.jsonData = jsonData.filter(item=>{
                            return item['站点ID']
                        }).map(item=>{
                            return {
                                ...item,
                                id: item['站点ID'],
                                name: item['站点名称'],
                            }
                        })
                        // 处理数据...
                        let checkData = await this.handleCheck(this.jsonData.map(item=>item.id))
                        this.errorData = checkData.filter(item=>{
                            return item.type === 1
                        })
                        this.hasOrderStationList = checkData.filter(item=>{
                            return item.type === 0
                        })
                        if(this.errorData.length || this.hasOrderStationList.length) {
                            this.$refs['upload'].clearFiles()
                        }
                    } catch (error) {
                        console.log(error);
                        this.$message.error('解析失败:', JSON.stringify())
                    }
                }else {
                    this.$message.error('未获取到文件内容')
                }
            },
            // 下载文件
            handleDownloadFile () {
                this.exportExcel([
                    {
                        '站点ID': '',
                        '站点名称': '',
                    }
                ], '站点挂起列表模板');
            },
            /**
             * 将Excel文件解析为JSON
             * @param {File} file - Excel文件对象
             * @returns {Promise<Array>} 解析后的JSON数据
             */
            excelToJson(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        try {
                            const data = new Uint8Array(e.target.result);
                            const workbook = XLSX.read(data, { type: 'array' });
                            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                            
                            // 获取键名行
                            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });
                            
                            if (json.length === 0) {
                                resolve([]);
                                return;
                            }
                            
                            const headers = json[0];
                            const result = json.slice(1).map(row => {
                                const obj = {};
                                headers.forEach((header, index) => {
                                    const key = String(header || `列${index + 1}`).trim().replace(/\s+/g, '_');
                                    obj[key] = row[index] !== undefined ? row[index] : '';
                                });
                                return obj;
                            });
                            
                            resolve(result);
                        } catch (error) {
                            reject(error);
                        }
                    };
                    
                    reader.onerror = () => reject(new Error('文件读取失败'));
                    reader.readAsArrayBuffer(file);
                });
            },
            /**
             * JSON数据生成Excel并下载（核心函数）
             * @param {Array|Object} data - JSON数据，可以是数组或对象(多sheet)
             * @param {string} fileName - 文件名（不含扩展名）
             * @param {Object} options - 配置选项
             */
            exportExcel(data, fileName = '导出数据', options = {}) {
                // 1. 创建工作簿
                const workbook = XLSX.utils.book_new();
                // 2. 处理多Sheet情况
                if (Array.isArray(data)) {
                    // 单Sheet：直接是数组
                    const worksheet = XLSX.utils.json_to_sheet(data);
                    // 设置列宽
                    if (options.columnWidths) {
                        worksheet['!cols'] = options.columnWidths;
                    }
                    XLSX.utils.book_append_sheet(workbook, worksheet, options.sheetName || 'Sheet1');
                } else {
                    // 多Sheet：data是对象，key是sheet名，value是数组
                    Object.entries(data).forEach(([sheetName, sheetData]) => {
                        if (Array.isArray(sheetData) && sheetData.length > 0) {
                            const worksheet = XLSX.utils.json_to_sheet(sheetData);
                            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                        }
                    });
                }
                
                // 3. 写入文件
                try {
                    XLSX.writeFile(workbook, `${fileName}.xlsx`);
                    console.log('Excel文件下载成功');
                    return true;
                } catch (error) {
                    console.error('Excel生成失败:', error);
                    return false;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    
</style>